// Pricing list helpers — one block per supplier.
//
// The Pricing list arrives as flat supplier / prefix groups, already sorted (supplier A-Z with "Other" last, then prefix).
// groupBySupplier puts them into one block per supplier so the screen and the print window can show a single orange supplier
// header with that supplier's prefixes underneath. Suppliers that differ only by case, spacing or punctuation are one supplier.

export const supplierKey = (supplier) =>
  String(supplier || 'Other').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

export const groupBySupplier = (groups) => {
  const bySupplier = new Map();
  (groups || []).forEach((g) => {
    const key = supplierKey(g.supplier);
    if (!bySupplier.has(key)) {
      bySupplier.set(key, { key, testKey: key.replace(/ /g, '-'), supplier: g.supplier || 'Other', groups: [], prices: [] });
    }
    const block = bySupplier.get(key);
    block.groups.push(g);
    block.prices.push(...g.prices);
  });
  return [...bySupplier.values()];
};
